var React = require('react');

function LoupeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.816 10.816C9.731 11.902 8.286 12.5 6.751 12.5c-1.535 0-2.978-.598-4.064-1.684-2.24-2.241-2.24-5.888 0-8.13 1.121-1.12 2.592-1.68 4.064-1.68s2.945.561 4.065 1.68c2.242 2.242 2.242 5.889 0 8.13m1.05.338c2.284-2.65 2.175-6.665-.338-9.18-2.633-2.632-6.92-2.632-9.552 0-2.635 2.635-2.635 6.92 0 9.554 1.275 1.276 2.97 1.979 4.775 1.979 1.636 0 3.18-.582 4.404-1.64l3.986 3.986c.099.099.227.147.355.147.13 0 .258-.048.357-.147.196-.196.196-.516 0-.712l-3.987-3.987z"}));
}

LoupeInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = LoupeInline;

LoupeInline.default = LoupeInline;
